var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "serviceNotAddedPopup" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content p-20" }, [
            _c("div", { staticClass: "text-right" }, [
              _c("div", { staticClass: "cursor-pointer" }, [
                _c("img", {
                  staticClass: "small",
                  attrs: {
                    src: require("../../../public/static/images/icons/close_icon.svg"),
                    alt: "close-icon",
                    "data-dismiss": "modal",
                    "data-target": "#serviceNotAddedPopup",
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "text-center" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../public/static/images/icons/expiring_soon.svg"),
                    alt: "expiringsoon-icon",
                  },
                }),
              ]),
              _c("p", { staticClass: "title pt-20 pb-40" }, [
                _vm._v(
                  " This service is not available as you are not subscribed. "
                ),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "ok-btn emergo-green-button mb-5",
                    attrs: {
                      "data-dismiss": "modal",
                      "data-target": "#serviceNotAddedPopup",
                    },
                  },
                  [_vm._v("OK")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }